// extracted by mini-css-extract-plugin
module.exports = {"logo":"Footer_logo__2rTLH","terms":"Footer_terms__3OdYX","notes":"Footer_notes__3neC8","cardStyling":"Footer_cardStyling__1kB6l"};